<template>
  <div>
    <ServerError v-if="ServerError" />
    <PageLoader v-bind:storage="appLoading" />
    <v-snackbar v-model="showSnackBar" color="#3CB043" left :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{ msg }}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: white">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center pb-10>
      <v-flex xs12 lg11 xl11 px-0 px-sm-4 pt-16 px-2 pr-xl-0>
        <!-- <v-layout wrap justify-center pt-16>
          <v-flex
            xs12
            sm12
            lg6
            xl6
            text-center
            text-uppercase
            style="font-family: poppinssemibold; font-size: 15px"
          >
            <span style="color: #30b868"> Cart </span>
            <span class="pl-4" style="letter-spacing: 10px; color: #a39f9f">
              &bullet;&bullet;&bullet;&bullet;&bullet;
            </span>
              <span class="pl-4" style="color: #a39f9f"> ADDRESS </span>
            <span class="pl-4" style="letter-spacing: 10px; color: #a39f9f">
              &bullet;&bullet;&bullet;&bullet;&bullet;
            </span>
            <span class="pl-4" style="color: #a39f9f"> PAYMENT </span>
          </v-flex>
        </v-layout> -->
        <v-layout wrap justify-start pt-16>
          <v-flex
            xs12
            sm3
            md3
            lg3
            xl3
            text-left
            style="font-family: poppinssemibold; font-size: 25px; color: #000000"
          >
            <span> Cart </span>
          </v-flex>
           <!-- Back to EcoShop Icon and Text (below Wishlist) -->
       
          <v-flex xs12  d-flex align-center>
            <router-link :to="'/ecoShop?shopname=' + ''+ '&id=' + ''">
            <v-icon 
              small
              class="mr-2"
              style="cursor: pointer; color: green;"
            >
              mdi-arrow-left
            </v-icon>
            <span
              style="
                color: green;
                font-family: poppinsregular;
                font-size: 16px;
                cursor: pointer;
              "
            >
              Back to EcoShop
            </span>
          </router-link>
          </v-flex>
       
          <!-- <v-flex
            xs12
            text-left
            v-if="sellerInfo"
            style="font-family: poppinsmedium; font-size: 13px; color: black"
          >
            <span> {{ sellerInfo.shopName }} </span>
          </v-flex> -->
        </v-layout>
        <v-layout wrap justify-start v-if="cart.length > 0">
          <v-flex xs12 sm12 md8 lg8 xl8 pt-4>
            <v-layout wrap justify-start>
              <v-card outlined width="100%" rounded="lg">
                <v-layout wrap pt-5>
                  <v-flex
                    xs12
                    sm12
                    pa-2
                    v-for="(item, i) in cart"
                    :key="i"
                    text-left
                  >
                    <v-layout wrap justify-center>
                      <v-flex xs12>
                        <CartItem
                          v-bind:storage="item"
                          :list="list"
                          v-bind:page="'cart'"
                          @stepper="winStepper"
                        />
                      </v-flex>
                      <v-flex xs12 py-4 v-if="i < cart.length - 1">
                        <v-divider></v-divider>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-card>
            </v-layout>
          </v-flex>
          <v-flex xs12 sm12 md4 lg4 xl4 pt-4>
            <OrderDetails v-bind:page="'cart'" :summary="summary" :promocode="promocode"
            @stepper="winStepper"
            />
          </v-flex>
          <!-- v-bind:storage="cart"
                v-bind:page="'cart'"
                :key="cart.total"
               @stepper="winStepper" -->
        </v-layout>
        <v-layout wrap justify-center pt-5 v-else>
          <v-flex xs12 pa-2 align-self-center>
            <span
              style="
                font-family: poppinsregular;
                font-size: 20px;
                color: #000000;
                cursor: pointer;
              "
              >Oops! No Products Found</span
            >
          </v-flex>
        </v-layout>
      </v-flex>
      <!-- <v-flex xs12 pt-10  v-if="relatedProducts.length>0">
        <v-divider></v-divider>
      </v-flex> -->
      <!-- v-if="relatedProducts.length>0" -->
      <v-flex xs12 sm12 pt-5>
        <SimilarProducts :relatedProducts="relatedProducts" />
      </v-flex>
    </v-layout>
  </div>
</template>
  <script>
import axios from "axios";
import CartItem from "./cartItem";
import OrderDetails from "./orderDetails";
import SimilarProducts from "./../EcoShop/similarProductsCart";
export default {
  components: {
    CartItem,
    OrderDetails,
    SimilarProducts,
  },
  data() {
    return {
      appLoading: false,
      ServerError: false,
      showSnackBar: false,
      timeout: 5000,
      msg: null,
      cart: [],
      summary: {},
      searchKey: null,
      pincode: null,
      list: [],
      lists: [
        {
          image: require("./../../assets/images/product1.png"),
          category: "Health",
          name: "Honey (Organic)",
          quantity: "500 Gm",
          price: "520",
          // price: "(₹ 620)",
        },
        {
          image: require("./../../assets/images/product2.png"),
          category: "Groceries ",
          name: "Pure Coconut Oil ",
          quantity: "500 ml",
          price: "250",
          // price: "(₹ 320)",
        },
        {
          image: require("./../../assets/images/product3.png"),
          category: "Personal Care",
          name: "Softening Creamy Soap Bar",
          quantity: "100 Gm",
          price: "120",
          // price: "(₹ 180)",
        },
      ],
      relatedProducts:[],
      sellerInfo:"",
      promocode:"",
    };
  },
  computed: {
    appLogin() {
      if (this.$store.state.isLoggedIn) return this.$store.state.isLoggedIn;
      else return null;
    },
    appUserId() {
      return this.$store.state.id
    },
    UserId() {
      return this.$store.state.userId;
    },
  },
  beforeMount() {
    this.getCart();
    // this.getProducts()
  },
  methods: {
    winStepper(window_data) {
      if (window_data.getData) {
        this.getCart();
      }
    },
    getCart() {
      this.appLoading = true;
      // var headers1 = {};
      // if (this.appLogin) {
      //   headers1 = {
      //     token: localStorage.getItem("token"),
      //   };
      // } else {
      //   headers1 = {
      //     guestId: localStorage.getItem("userId"),
      //   };
      // }
      axios({
        url: "/cart/listview",
        method: "POST",
        headers: {
          token: localStorage.getItem("token"),
        },
        data:{
          userId: localStorage.getItem("id"),
          guestId: localStorage.getItem("userId"),
        }
      })
        .then((response) => {
          this.appLoading = false;
          this.cart = response.data.cartItems;
          this.summary = response.data;
          // if(response.data.promocode.length>0){
          // this.promocode=response.data.promocode[0]
          // }
          // this.sellerInfo=response.data.sellerInfo;
          this.$store.commit("changeCart", response.data.cartCount);
          for (var i = 0; i <= this.cart.length; i++) {
            for (var l = 1; l <= this.cart[i].itemId.stock[0].stock; l++) {
              this.list.push(l);
            }
          }
        })
        .catch((err) => {
          this.appLoading = false;
          // this.ServerError = true;
          console.log(err);
        });
    },
    getProducts() {
      this.appLoading = true;
      var headers1 = {};
      if (this.appLogin) {
        headers1 = {
          token: localStorage.getItem("token"),
        };
      } else {
        headers1 = {
          guestId: localStorage.getItem("userId"),
        };
      }
      axios({
        url: "/cart/similarProducts",
        method: "GET",
        headers: headers1,
      })
        .then((response) => {
          this.appLoading = false;
          this.relatedProducts=response.data.data
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },
  },
};
</script>
  